<template>
  <div>
    <v-dialog
      scrollable
      v-model="confirmArchiveReportDialog"
      persistent
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">{{
          $t("components.demographicstable.archive_report")
        }}</v-card-title>
        <v-card-text>{{
          $t("components.demographicstable.proceed_with_archiving_a_report")
        }}</v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="saving"
            color
            text
            @click="confirmArchiveReportDialog = false"
            >{{ $t("globals.cancel") }}</v-btn
          >
          <v-btn :loading="saving" color="primary" @click="archiveReport()">
            {{ $t("components.demographicstable.archive_report") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container v-if="!headers">
      <v-row justify="center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="accent"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </v-container>
    <material-card v-show="headers" elevation="0">
      <!--data-table
        ref="table"
        :headers="headers"
        tableKey="Id"
        :show-select="true"
        :selectAll="true"
        @odataItems="setData($event)"
        :selectActions="selectActions"
        :tableActions="tableActions"
        :displayFunctions="displayFunctions"
        :columnsOptions="columnsOptions"
        @customHeaders="saveHeaders($event)"
        :provider="provider"
      ></data-table-->
      <pbas-data-table
        :exporters="$exporters"
        ref="table"
        :dataProvider="provider"
        :selectActions="selectActions"
        :tableActions="tableActions"
        fileNamePrefix="demographics"
        :identifier="identifier"
        @itemsChanged="setData($event)"
        @error="error=$event"
      ></pbas-data-table>
      <error-handler :error="error"></error-handler>
    </material-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import {
  ODataHeader,
  ODataCustom,
  ODataEquals,
  ODataGreaterThan,
  ODataLowerThan,
  ODataGreaterThanOrEquals,
  ODataLowerThanOrEquals,
  ODataInteger,
  ODataString,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import ErrorHandler from "../components/ErrorHandler";

export default {
  name: "demographics-table",
  components: {ErrorHandler},
  props: [
    "url",
    "saving",
    "inArchive",
    "insuranceCarrier",
    "date",
    "identifier",
  ],
  data() {
    return {
      error: null,
      archiveTarget: null,
      provider: undefined,
      columnsOptions: {},
      displayFunctions: {},
      selectActions: [],
      tableActions: [],
      confirmArchiveReportDialog: false,
      headers: null,
      items: [],
      selected: [],
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", { columnsDropDownOptions: "options" }),
    tableTitle() {
      return "Demographics";
    },
  },
  watch: {
    url: {
      handler(v) {
        //console.log("url: ", v);
        if (v) this.loadPlanData();
      },
    },
  },
  async mounted() {
    this.loadPlanData();
    if (this.inArchive === true) {
      //console.log("in archive");
      this.tableActions = [];
      this.selectActions = [];
    } else {
      //console.log("not in archive");
      this.selectActions = [
        {
          name: "archiveReport",
          icon: "edit",
          title: "Archive Report",
          handler: () => {
            this.selected = this.$refs.table.selected;
            this.archiveTarget = "selected";
            this.confirmArchiveReportDialog = true;
          },
        },
      ];
      this.tableActions = [
        {
          name: "archiveReportPage",
          icon: "edit",
          title: "Archive Report (Page)",
          handler: () => {
            this.archiveTarget = "page";
            this.confirmArchiveReportDialog = true;
          },
        },
        {
          name: "archiveReportAll",
          icon: "edit",
          title: "Archive Report",
          handler: () => {
            this.archiveTarget = "all";
            this.confirmArchiveReportDialog = true;
          },
        },
      ];
    }
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    ...mapActions("plansMembers", [
      "getDemographicsColumns",
      "getDemographicsInsuranceCarrierCoverage",
    ]),
    ...mapActions("common", ["createOdataType"]),
    async loadPlanData() {
      try {
        let headers = (await this.getDemographicsColumns(
          this.selectedPlan.Id
        )).data.sort((a, b) => {
          return a.order - b.order;
        });

        //console.log("Headers: ", headers);
        this.headers = this.$helpers.createOdataHeaders(headers, "headers.demographics.");

        let coverage = (await this.getDemographicsInsuranceCarrierCoverage({
        plan: this.selectedPlan.Id,
        date: this.date,
        insuranceCarrier: this.insuranceCarrier.Id,
      })).data.value;
      for (let c of coverage) {
        let ch = new ODataHeader({
          title: translate2(c, "Name"),
          type: new ODataCustom(
            "Identity/VolumeOfCoverage[]/CoverageIdentity/Current/Name",
            {
              getString: (item, type) => {
                return this.coverageDisplayFunc(c.Name, item);
              },
              getWildcardFilter: (search) => {
                return `Identity/VolumeOfCoverage/any(_volumeOfCoverage:contains(cast(_volumeOfCoverage/Value,'Edm.String'),'${search.toLowerCase()}') and _volumeOfCoverage/CoverageIdentity/Current/Name eq '${encodeURIComponent(
                  c.Name
                )}')`;
              },
              getFilter: (callback) => {
                const res = callback("_volumeOfCoverage/Value");
                return `Identity/VolumeOfCoverage/any(_volumeOfCoverage: ${res} and _volumeOfCoverage/CoverageIdentity/Current/Name eq '${
                  c.Name
                }')`;
              },
              operators: [
                new ODataEquals(),
                new ODataGreaterThan(),
                new ODataLowerThan(),
                new ODataGreaterThanOrEquals(),
                new ODataLowerThanOrEquals(),
              ],
            }
          ),
          sortable: false,
          visible: true,
          searchable: true,
          version: 5,
        });
        this.headers.push(ch);
        //console.log(JSON.stringify(ch));
      }

        if (this.provider) {
          this.provider = new PbasOData(
            this.$axiosHttp,
            this.url,
            this.headers
          );
          this.$nextTick(() => {
            this.$refs.table.getDataAsync();
          });
        } else
          this.provider = new PbasOData(
            this.$axiosHttp,
            this.url,
            this.headers
          );
      } catch (error) {
        console.log("error");
        this.$emit("onerror", error);
        this.headers = [];
      }
    },
    
    coverageDisplayFunc(coverageName, item) {
      if (item.Identity.VolumeOfCoverage) {
        let coverage = item.Identity.VolumeOfCoverage.filter((o) => {
          //console.log(o);
          return o.CoverageIdentity.Current.Name === coverageName;
        });
        if (coverage.length > 0) {
          let value = coverage[0].Value;
          if (value === null || value === undefined) return "";
          if (typeof value !== "number") {
            return value;
          }
          var formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
          });
          return formatter.format(value);
        }
      }
      return "";
    },
    setData(items) {
      this.items = items;
    },
    async archiveReport() {
      let items = [];
      switch (this.archiveTarget) {
        case "selected": {
          //console.log(this.selected);
          items = this.selected.map((o) => o.Id);
          break;
        }
        case "page": {
          items = this.items.map((o) => o.Id);
          break;
        }
        case "all": {
          let allitems = await this.$refs.table.getAll(["Id"]);
          //console.log(allitems);
          items = allitems.map((o) => o.Id);
          break;
        }
        default: {
          break;
        }
      }
      this.$emit("archive", items);
    },
    getDataAsync() {
      return this.$refs.table.getDataAsync();
    },
  },
};
</script>

<style></style>
